
import * as yup from "yup"

yup.setLocale({
    mixed: {
        default: 'Invalido',
        required: 'Campo requerido',
    },
    number: {
        min: 'El numero debe ser mayor a ${min}',
        max: 'El numero debe ser menor a ${max}',
        positive: 'El numero debe ser positivo',
        integer: 'El numero debe ser entero'
    },
    string: {
        min: 'El texto debe incluir al menos ${min} caracteres.',
        max: 'El texto no puede ser mayor a ${max} caracteres.',
    }
});

export default yup